import React from "react";
import moment from "moment";
import Table from "./Table";

const LoginHistoryTable = ({ loginHistory, sortColumn, onSort }) => {
  const columns = [
    {
      key: "DisplayName",
      path: "DisplayName",
      label: "Display Name",
      content: (login) => login.DisplayName || login.Username,
    },
    { path: "BusinessUnitName", label: "Business Unit" },
    { path: "SiteUrl", label: "Site URL" },
    {
      key: "Build",
      label: "Build #",
      content: (login) => {
        if (login.Details) {
          const details = JSON.parse(login.Details);
          return details.Build;
        }
      },
    },
    {
      key: "Browser",
      label: "Browser",
      content: (login) => {
        if (login.Details) {
          const details = JSON.parse(login.Details);
          return details.Browser;
        }
      },
    },
    {
      key: "OS",
      label: "OS",
      content: (login) => {
        if (login.Details) {
          const details = JSON.parse(login.Details);
          return details.OS;
        }
      },
    },
    {
      key: "LogCreatedEst",
      path: "LogCreatedEst",
      label: "Log Created",
      content: (login) => moment(login.LogCreatedEst).format("LLL"),
    },
  ];

  return (
    <Table
      columns={columns}
      data={loginHistory}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default LoginHistoryTable;
